<rid-mechanic-background />

@let _state = state();

<rid-mechanic-wrapper>
  <rid-top-bar class="block w-full" name="Dictee | Digitaal zinnen" [steps]="sentences().length" [progress]="index()" />

  <rid-mechanic-content>
    <!-- title -->
    @for (input of [instruction()]; track input) {
      <rid-mechanic-title [title]="input" animate.enter="wait-500" />
    }

    <!-- content -->
    @for (input of [sentenceKey()]; track input) {
      <div class="absolute flex max-w-4xl flex-col place-items-center gap-4 px-8" animate.leave="anim-fade-out">
        <div class="relative">
          <rid-audio-button src="FOR SIZING" size="MEDIUM" class="pointer-events-none invisible" />

          <rid-audio-button
            #audioButton
            class="absolute inset-0"
            [src]="{ pronounce: sentence() }"
            size="MEDIUM"
            animate.enter="wait-500 anim-pop-in"
            ridSfx="BUBBLE_POP"
            (animationend)="$event.animationName === 'pop-in' ? start() : undefined"
          />
        </div>

        @if (_state.type === 'REVEAL') {
          <div
            class="font-default text-text-primary max-w-4xl rounded-3xl border-2 border-slate-200 bg-white px-8 py-6 text-center text-3xl shadow-lg shadow-slate-900/8"
            animate.enter="anim-pop-in"
            animate.leave="anim-pop-out"
            ridSfx="HINT"
          >
            {{ sentence() }}
          </div>
        } @else {
          <rid-text-input
            class="w-full min-w-2xl"
            [appearance]="appearance()"
            [solid]="true"
            animate.enter="wait-750 anim-pop-in"
            ridSfx="BUBBLE_POP"
          >
            <div class="font-default text-text-primary min-h-12 px-6 py-2 text-center text-3xl leading-snug">
              @for (char of displayChars(); track $index) {
                <span
                  [class.text-red-500]="mismatchIndices().has($index) && appearance() !== 'ALMOST'"
                  [class.text-orange-500]="mismatchIndices().has($index) && appearance() === 'ALMOST'"
                  [class.underline]="mismatchIndices().has($index)"
                  >{{ char }}</span
                >
              }
              @if (_state.type === 'WRITING' || _state.type === 'AUDIO') {
                <span class="bg-text-primary ml-0.5 inline-block h-7 w-1 animate-pulse rounded-full align-middle"></span>
              }
            </div>
          </rid-text-input>
        }
      </div>
    }

    @if (_state.type === 'WRITING' && text().length > 0) {
      <rid-bottom-button content="Klaar!" keybind="Enter" (clicked)="check()" />
    }

    @if (_state.type === 'RETRY') {
      <rid-bottom-button content="Probeer nog eens" keybind="Enter" (clicked)="retry()" />
    }

    @if (_state.type === 'REVEAL') {
      <rid-bottom-button content="Volgende" keybind="Enter" (clicked)="next()" />
    }

    <!-- feedback overlay -->
    <rid-overlay-feedback #overlayFeedback />
  </rid-mechanic-content>
</rid-mechanic-wrapper>
